import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { InvoiceListInvoiceNumberCell } from './invoice-list-invoice-number.cell';
import { InvoiceListInvoiceNumberHeader } from './invoice-list-invoice-number.header';

export const InvoiceListInvoiceNumberColumn: IdentifiedColumnDef<
  InvoiceModel,
  InvoiceModel['invoiceNumber']
> = {
  enableSorting: false,
  header: InvoiceListInvoiceNumberHeader,
  cell: InvoiceListInvoiceNumberCell,
};
